import React from 'react'

import { emitOpenNoteModal } from 'helpers/events'

import { Container, Wrapper, NoteIcon, BadgeCount } from './styles'

const Note = ({ studentsCount, userNotes, userId, userName, isTeacher }) => {
    console.count('Note Component')

    const activeNotesCount = userNotes.filter(item => !item.note.isDeleted)
        .length

    return (
        <Container
            studentsCount={studentsCount}
            isTeacher={isTeacher}
            onClick={() => emitOpenNoteModal({ userId, userName })}
        >
            <Wrapper>
                <NoteIcon
                    src="/assets/revamp/insert_drive_file.svg"
                    alt="note-icon"
                />
                <BadgeCount>{activeNotesCount}</BadgeCount>
            </Wrapper>
        </Container>
    )
}

export default Note
